// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"401":"b3debe0c","622":"63b292a8"}[chunkId] + ".chunk.js";
};